import fondo from '../../assets/fondo.png';
import '../../styles/base.css';
function Base() {
    return(  
       <div className="base">
          <div className = 'div-fondo'>
               <img className = 'fondo' src={fondo} alt="GARAGEGDL" />
          </div>
       </div>
   )
   }
   export default Base;